var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag",class:{
    tag__round: _vm.status === 'round',
    tag__reserved: _vm.status === 'reserved',
    tag__express: _vm.status === 'express',
  }},[_vm._v(" "+_vm._s(_vm.returnStatus())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }